
import {
  defineComponent, shallowRef, onMounted, ref, watch, defineEmits, onUnmounted,computed,
} from 'vue';
// import caronMap from './components/caronMap.vue';
import {
  Input, Table, ConfigProvider, Tooltip, InputNumber,
} from 'ant-design-vue';
import moment, { Moment, } from 'moment';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { CheckOutlined, EditOutlined, QuestionCircleFilled, } from '@ant-design/icons-vue';
import { indexTypes, } from '@/configs/index';

import store from '@/store';
import { number, } from 'echarts';

export default defineComponent({
  components: {
    ConfigProvider,
    Table,
    InputNumber,
    Tooltip,
    CheckOutlined,
    EditOutlined,
    QuestionCircleFilled,
  },
  setup (props,{ emit, }) {
    // 列表行配置1
    const columns1 = [
      {
        title: '月份',
        align: 'center',
        dataIndex: 'month',
        key: 'month',
        width: '4%',
      },
      {
        title: '目标分解(天)',
        align: 'center',
        dataIndex: 'decompose',
        key: 'decompose',
        slots: { customRender: 'decompose', },
        width: '10%',
        ellipsis: true,
      },
      {
        title: '今年实际(天)',
        align: 'center',
        dataIndex: 'current',
        key: 'current',
        slots: { customRender: 'current', },
        width: '10%',
        ellipsis: true,
      },
      {
        title: '去年同期(天)',
        align: 'center',
        dataIndex: 'lastYear',
        key: 'lastYear',
        slots: { customRender: 'lastYear', },
        width: '10%',
        ellipsis: true,
      },
      {
        align: 'center',
        dataIndex: 'curDays',
        key: 'curDays',
        slots: { title: 'customTitle1', },
        width: '10%',
        ellipsis: true,
      },
      {
        title: '是否达标',
        align: 'center',
        dataIndex: 'isQualified',
        key: 'isQualified',
        slots: { customRender: 'isQualified', },
        width: '10%',
        ellipsis: true,
      },
    ];
    // 列表行配置2
    const columns2 = [
      {
        title: '月份',
        align: 'center',
        dataIndex: 'month',
        key: 'month',
        width: '4%',
      },
      {
        title: '目标分解(ug/m3)',
        align: 'center',
        dataIndex: 'decompose',
        key: 'decompose',
        slots: { customRender: 'decompose', },
        width: '10%',
        ellipsis: true,
      },
      {
        title: '今年实际(ug/m3)',
        align: 'center',
        dataIndex: 'current',
        key: 'current',
        slots: { customRender: 'current', },
        width: '10%',
        ellipsis: true,
      },
      {
        title: '去年同期(ug/m3)',
        align: 'center',
        dataIndex: 'lastYear',
        key: 'lastYear',
        slots: { customRender: 'lastYear', },
        width: '10%',
        ellipsis: true,
      },
      {
        align: 'center',
        dataIndex: 'curDays',
        key: 'curDays',
        slots: { title: 'customTitle2', },
        width: '10%',
        ellipsis: true,
      },
      {
        title: '是否达标',
        align: 'center',
        dataIndex: 'isQualified',
        key: 'isQualified',
        slots: { customRender: 'isQualified', },
        width: '10%',
        ellipsis: true,
      },
    ];
    // 列表行配置
    const columns = ref<any>(columns1);
    const tableData = ref<any>([]);
    // 当前类型配置
    const types = ref<any>([]);
    // 表格当前显示类型
    const curType = ref<number>(0);
    const getPopupContainer = () => document.getElementById('cur-container');
    // 当前编辑数据的index
    const tableIndex = ref<number>(-1);
    // 当前列
    const curCol = ref<string>('');
    // 编辑框数据
    const tmpInput = ref<number>(0);
    // 年份
    const curYear = ref<string>('');
    // 计算优良率
    const fineDaysRate = (val:number) => {
      const totalDays = moment().isLeapYear() ?
        366 :
        365;

      const res = ((100 * val) / totalDays).toFixed(1);

      return res;
    };

    const toAnnualPage = () => {
      emit('isShow',false);
    };
    // 获取某年年度目标
    const getAnnualData = async (year:string) => {
      const params = {
        year,
      };
      const dataList = await store.dispatch('target/getCurYear', params);

      // 根据返回值，更新当前类型配置
      if (dataList) {
        indexTypes.forEach((item) => {
          const { type, } = item;

          if (dataList[type]) {
            types.value.push({ ...item,data: dataList[type], });
          }
        });
        curYear.value = dataList.year;
        // 请求分解表格数据
        const params2 = {
          year: curYear.value,
          type: types.value[curType.value].type,
        };
        const res = await store.dispatch('target/getMonTable', params2);

        tableData.value = res;
      }
    };
    // 表格数据更新
    const update = (id:string,yearData:string,month:string,typeData:string,data:any,col:string) => {
      let year = yearData;
      let type = typeData;

      if (col === 'current') {
        type = `${type}R`;
      } else if (col === 'lastYear') {
        type = `${type}R`;
        year = String(Number(year) - 1);
      }
      // 月份处理
      if (month !== '全年') {
        const tmpMon = `0${month}`;

        year += tmpMon.slice(-3,-1);
      }
      const params = {
        id,
        year,
        [type]: data,
      };

      store.dispatch('target/updateMonTable',params);
    };
    // 表格类型切换
    const changeType = async (val:number) => {
      if (curType.value !== val) {
        curType.value = val;
        const params = {
          year: curYear.value,
          type: types.value[val].type,
        };
        const res = await store.dispatch('target/getMonTable', params);

        tableData.value = res;

        if (types.value[val].type === 'fineDays') {
          columns.value = columns1;
        } else {
          columns.value = columns2;
        }
      }
    };
    // 编辑框编辑
    const edit = (val:any,text:number,col:string) => {
      tableIndex.value = val;
      curCol.value = col;
      tmpInput.value = text;
    };
    // 编辑框保存
    const save = (val:any,col:string) => {
      tableIndex.value = -1;
      curCol.value = '';
      tableData.value[val][col] = tmpInput.value;
      const { id, month, } = tableData.value[val];
      const { type, } = types.value[curType.value];

      update(id,curYear.value,month,type,tmpInput.value,col);

      tmpInput.value = 0;
    };

    onMounted(() => {
      // 当年年份
      const nowYear = moment().format('YYYY');

      getAnnualData(nowYear);
    });
    onUnmounted(() => {
      store.commit('target/setStateItem', { value: {}, type: 'annualList', });
    });

    return {
      zhCN,
      types,
      curType,
      columns,
      tableData,
      tableIndex,
      curCol,
      tmpInput,
      curYear,
      getPopupContainer,
      changeType,
      edit,
      save,
      toAnnualPage,
      fineDaysRate,
    };
  },
});
